import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { useLanguage } from '../../hooks/useLanguage';
import { extractLanguageCode } from '../../utils/languageUtils';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const { changeLanguage: changeLang } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const languages = [
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
  ];

  // Extract 2-letter code from i18n language (handles 'fr-FR' -> 'fr')
  const currentLangCode = extractLanguageCode(i18n.language);
  const currentLanguage = languages.find((lang) => lang.code === currentLangCode) || languages[0];

  const handleLanguageChange = async (languageCode) => {
    await changeLang(languageCode);
    setIsOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="language-switcher-wrapper" ref={dropdownRef}>
      <div className="language-switcher-group">
        <button 
          className="language-switcher-button"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Select Language"
        >
          <Globe size={18} className="language-switcher-icon" />
          <span className="language-switcher-text">
            {currentLanguage.flag} {currentLanguage.code.toUpperCase()}
          </span>
        </button>

        {/* Dropdown */}
        {isOpen && (
          <div className="language-switcher-dropdown show">
            {languages.map((language) => (
              <button
                key={language.code}
                onClick={() => handleLanguageChange(language.code)}
                className={`language-switcher-option ${
                  currentLangCode === language.code ? 'active' : ''
                }`}
              >
                <span className="language-switcher-flag">{language.flag}</span>
                <span className="language-switcher-name">{language.name}</span>
                {currentLangCode === language.code && (
                  <span className="language-switcher-check">✓</span>
                )}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default LanguageSwitcher;

